import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=5c213a8a&scoped=true"
import script from "./baseInfo.vue?vue&type=script&lang=js"
export * from "./baseInfo.vue?vue&type=script&lang=js"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=5c213a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c213a8a",
  null
  
)

export default component.exports